/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseGraphicsGraphicIdNotFound
 */
export interface GetUniverseGraphicsGraphicIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseGraphicsGraphicIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseGraphicsGraphicIdNotFound interface.
 */
export function instanceOfGetUniverseGraphicsGraphicIdNotFound(value: object): value is GetUniverseGraphicsGraphicIdNotFound {
    return true;
}

export function GetUniverseGraphicsGraphicIdNotFoundFromJSON(json: any): GetUniverseGraphicsGraphicIdNotFound {
    return GetUniverseGraphicsGraphicIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseGraphicsGraphicIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseGraphicsGraphicIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseGraphicsGraphicIdNotFoundToJSON(json: any): GetUniverseGraphicsGraphicIdNotFound {
    return GetUniverseGraphicsGraphicIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseGraphicsGraphicIdNotFoundToJSONTyped(value?: GetUniverseGraphicsGraphicIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

